// extracted by mini-css-extract-plugin
export var cartIcon = "_om-0";
export var cartIconContainer = "_om-1";